export enum FeatureFlags {
  Transcript = 'transcription-summary',
  ScreenRecording = 'screen-recording',
  faceLandmarks = 'face-landmarks',
  noiseReduction = 'noise-reduction',
  subtitles = 'subtitles',
  candidatePolling = 'candidate-polling',
  metadataCollector = 'metadata-collector',
}
